import React, { useState } from "react";
import { formatDate } from "../../../../../../Helper_functions";
import IconSwitch from "../../../ShareElements/Switch/IconSwitch";
import TextAreaNoLabel from "../../../ShareElements/TextInput/TextAreaNolabel";
import SimpleTextInputNoLabel from "../../../ShareElements/TextInput/TextInputNolabel";
import Datepicker from "../../Components/DatePicker";
import AvalilabilityDatepicker from "../../../ShareElements/AvailabilityDatepicker/AvailabilityDatepicker";
import Select from "../../../ShareElements/Select/Select";
import OpenAILogo from "../../../../../../Assets/Images/openai.svg";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import axios from "axios";

const MobileStep1 = (props) => {
  const [StartDateIsOpen, setStartDateIsOpen] = useState(false);
  const [EndDateIsOpen, setEndDateIsOpen] = useState(false);
  const [SelectedStartDate, setSelectedStartDate] = useState();
  const [SelectedEndDate, setSelectedEndDate] = useState();
  const [MaxDate, setMaxDate] = useState();
  const [MinDate, setMinDate] = useState();
  const [LanguageOptions] = useState([
    { name: "English", id: "en" },
    { name: "German", id: "de" },
  ]);
  const [IsGenerating, setIsGenerating] = useState(false);
  const [GenerateBtnIsDisabled, setGenerateBtnIsDisabled] = useState(true);
  const [DescriptionIsAutofilled, setDescriptionIsAutofilled] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const saveStartDate = (StartDate) => {
    props.SetHasUnsavedChanges();
    setSelectedStartDate(formatDate(new Date(StartDate).getTime()));
    setStartDateIsOpen(false);
    props.SaveStartDate(new Date(StartDate).toISOString()); // saves the selected date as a state in the parent to send to API when saving
    setMinDate(new Date(StartDate));
  };

  const saveEndDate = (EndDate) => {
    props.SetHasUnsavedChanges();
    setSelectedEndDate(formatDate(new Date(EndDate).getTime()));
    setEndDateIsOpen(false);
    props.SaveEndDate(new Date(EndDate).toISOString()); // saves the selected date as a state in the parent to send to API when saving
    setMaxDate(new Date(EndDate));
  };

  const handleTitleChange = () => {
    props.SetHasUnsavedChanges();

    if (document.getElementById("title").value.length > 5) {
      setGenerateBtnIsDisabled(false);
    } else if (!GenerateBtnIsDisabled) {
      setGenerateBtnIsDisabled(true);
    }
  };

  const handleDescChange = () => {
    props.SetHasUnsavedChanges();

    if (document.getElementById("description").value.length > 0) {
      setDescriptionIsAutofilled(true);
    } else {
      setDescriptionIsAutofilled(false);
    }
  };

  const displayTitlePlaceholder = () => {
    if (props.JPAType === "job") {
      return "Title of vacancy";
    } else if (props.JPAType === "project") {
      return "Title of project";
    } else if (props.JPAType === "activity") {
      return "Title of activity";
    }
  };

  const requestGenerateJPADescription = () => {
    setIsGenerating(true);

    let Req = {
      method: "POST",
      baseURL: window._env_.ASKMEANYTHING_URL + "/jpa_description",

      data: {
        title: document.getElementById("title").value,
        lang: document.getElementById("generate-lang-filter").value,
        token: window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsGenerating(false);
        document.getElementById("description").value = Res.data.description;
        setDescriptionIsAutofilled(true);
      })
      .catch((Err) => {
        console.log(Err);
        setIsGenerating(false);
      });
  };

  return (
    <React.Fragment>
      <section className="step-row">
        <h1 className="row-title">
          {translateText("title")}
          <p className="mandatory">*</p>
        </h1>
        <SimpleTextInputNoLabel
          Id="title"
          PlaceHolder={displayTitlePlaceholder()}
          ValidationMessage=""
          ChangeEvent={() => handleTitleChange()}
        />
      </section>
      <section className="step-row">
        <h1 className="row-title">
          {translateText("owner_name")}
          <p className="mandatory">*</p>
        </h1>
        <input id="owner-name" disabled />
        <p className="owner-name-placeholder">
          {props.UserInfo !== undefined
            ? props.UserInfo.firstName + " " + props.UserInfo.lastName
            : null}
        </p>
      </section>
      <section className="step-row availability-row">
        <h1 className="row-title">{translateText("availability")}</h1>
        {
          <AvalilabilityDatepicker
            LangData={props.LangData}
            HideStartDate
            HideEndDate
          />
        }
      </section>
      <section className="step-row">
        <h1 className="row-title">
          {translateText("start_date")}
          <p className="mandatory">*</p>
        </h1>
        {StartDateIsOpen ? (
          <React.Fragment>
            <div
              className="date-trigger"
              onClick={() => setStartDateIsOpen(true)}
            >
              <i className="feather-calendar"></i>
              {SelectedStartDate === undefined ? (
                <p className="datepicker-placeholder" id="selected-start-date">
                  {translateText("start_date")}
                </p>
              ) : (
                <p
                  className="datepicker-placeholder filled-date"
                  id="selected-start-date"
                >
                  {SelectedStartDate}
                </p>
              )}
            </div>
            <div className="datepicker-holder">
              <Datepicker
                Close={() => setStartDateIsOpen(false)}
                SaveSelectedDate={(StartDate) => saveStartDate(StartDate)}
                MaxDate={MaxDate}
              />
            </div>
          </React.Fragment>
        ) : (
          <div className="date-trigger">
            <i
              className="feather-calendar"
              onClick={() => setStartDateIsOpen(true)}
            ></i>
            {SelectedStartDate === undefined ? (
              <p
                className="datepicker-placeholder"
                id="selected-start-date"
                onClick={() => setStartDateIsOpen(true)}
              >
                {translateText("start_date")}
              </p>
            ) : (
              <p
                className="datepicker-placeholder filled-date"
                id="selected-start-date"
                onClick={() => setStartDateIsOpen(true)}
              >
                {SelectedStartDate}
              </p>
            )}
            {SelectedStartDate === undefined ? null : (
              <i
                className="feather-x-circle"
                onClick={() => {
                  setSelectedStartDate(undefined);
                  setMinDate(undefined);
                  props.SaveStartDate("");
                }}
              ></i>
            )}
          </div>
        )}
      </section>
      <section className="step-row">
        <h1 className="row-title">{translateText("end_date")}</h1>
        {EndDateIsOpen ? (
          <React.Fragment>
            <div
              className="date-trigger"
              onClick={() => setEndDateIsOpen(true)}
            >
              <i className="feather-calendar"></i>
              {SelectedEndDate === undefined ? (
                <p className="datepicker-placeholder">
                  {translateText("end_date")}
                </p>
              ) : (
                <p className="datepicker-placeholder filled-date">
                  {SelectedEndDate}
                </p>
              )}
            </div>
            <div className="datepicker-holder">
              <Datepicker
                Close={() => setEndDateIsOpen(false)}
                SaveSelectedDate={(EndDate) => saveEndDate(EndDate)}
                MinDate={MinDate}
              />
            </div>
          </React.Fragment>
        ) : (
          <div className="date-trigger">
            <i
              className="feather-calendar"
              onClick={() => setEndDateIsOpen(true)}
            ></i>
            {SelectedEndDate === undefined ? (
              <p
                className="datepicker-placeholder"
                onClick={() => setEndDateIsOpen(true)}
              >
                {translateText("end_date")}
              </p>
            ) : (
              <p
                className="datepicker-placeholder filled-date"
                onClick={() => setEndDateIsOpen(true)}
              >
                {SelectedEndDate}
              </p>
            )}
            {SelectedEndDate === undefined ? null : (
              <i
                className="feather-x-circle"
                onClick={() => {
                  setSelectedEndDate(undefined);
                  setMaxDate(undefined);
                }}
              ></i>
            )}
          </div>
        )}
      </section>
      <section className="step-row">
        <h1 className="row-title">{translateText("publish")}</h1>
        <div className="publish-switch-holder">
          <IconSwitch Id="created-jpa" ChangeEvent={() => null} />
        </div>
      </section>
      <section className="step-row">
        <h1 className="row-title description-label">
          {translateText("description")}
        </h1>
        <TextAreaNoLabel
          Id="description"
          PlaceHolder={DescriptionIsAutofilled ? "" : translateText("optional")}
          ValidationMessage=""
          ChangeEvent={() => handleDescChange()}
        />
      </section>
      <section className="generate-desc-holder">
        <Select
          Id="generate-lang"
          Options={LanguageOptions}
          Initial={"English"}
          IsWithId
          PreSelected={true}
          PreSelectedId={"en"}
          ChangeHandler={() => null}
          ValidationError=""
        />
        <span
          className={
            GenerateBtnIsDisabled
              ? "generate-button disabled"
              : "generate-button"
          }
          onClick={
            IsGenerating || GenerateBtnIsDisabled
              ? () => null
              : () => requestGenerateJPADescription()
          }
        >
          {IsGenerating ? (
            <img alt="" className="rotator" src={Rotator} />
          ) : (
            <>
              <img alt="" src={OpenAILogo} /> {translateText("generate")}
            </>
          )}
        </span>
      </section>
    </React.Fragment>
  );
};

export default MobileStep1;
